import { createSelector } from "reselect"
import { initialState } from "./reducer"

const selectWidgetQualitativeBubblesDomain = (state) =>
  state.get("widgetQualitativeBubblesV2", initialState)

export const makeSelectIsLoadingWordcloud = () =>
  createSelector(selectWidgetQualitativeBubblesDomain, (state) =>
    state.get("isLoadingWordcloud")
  )

export const makeSelectTotalAnswers = () =>
  createSelector(selectWidgetQualitativeBubblesDomain, (state) =>
    state.get("totalAnswers")
  )

export const makeSelectWords = () =>
  createSelector(selectWidgetQualitativeBubblesDomain, (state) =>
    state.get("words")
  )

export const makeSelectIsLoadingQuestions = () =>
  createSelector(selectWidgetQualitativeBubblesDomain, (state) =>
    state.get("isLoadingQuestions")
  )

export const makeSelectQuestions = () =>
  createSelector(selectWidgetQualitativeBubblesDomain, (state) =>
    state.get("questions")
  )

const makeSelectWidgetQualitativeBubbles = () =>
  createSelector(selectWidgetQualitativeBubblesDomain, (substate) =>
    substate.toJS()
  )

export default makeSelectWidgetQualitativeBubbles
export { selectWidgetQualitativeBubblesDomain }
